export class MiscellaneousSettings {
  public enablePWA = false;
}
